import { TableCell, TableRow } from '@material-ui/core';
import moment from 'moment';
import React from 'react';

const WLDTableCells = ({ styles, mykey, row  }) => {
  return (
    <TableRow style={{ ...styles.tableRow, height: '5px' }} key={mykey}>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '70px',
        }}
        align="center"
      >
        {moment(row.date).format('DD-MMM-YY')}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        ${parseFloat(row.Stock).toFixed(2)}
      </TableCell>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        {row.symbol}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        {moment(row.Expiry).format('DD-MMM-YY')}
      </TableCell>
      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        ${row.Strike.toFixed(2)}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          textAlign: 'center',
          width: '45px',
        }}
        align="center"
      >
        {row.PutCall}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
        }}
        align="center"
      >
        ${row.Price.toFixed(2)}
      </TableCell>

      <TableCell
        style={{
          ...styles.modalTableRow,
          padding: 6,
          width: '45px',
          backgroundColor: '#FFFCD1',
        }}
        align="center"
      >
        {row.RR ? '$' + row.RR.toFixed(2) : '-'}
      </TableCell>
    </TableRow>
  );
};
export default WLDTableCells;



// WEBPACK FOOTER //
// ./src/components/Modals/WatchListDelte/components/WLDTableCells.jsx